// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1qrGj","noInteraction":"EventWrapper_noInteraction__6hnZV"};